import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const RegistrationForm = () => {
  const { t } = useTranslation('auth');
  return <p dangerouslySetInnerHTML={{ __html: t('How to register') }}></p>;
};

RegistrationForm.propTypes = {
  hasLabel: PropTypes.bool
};

export default RegistrationForm;
